export const keepEntries = (obj, keysToKeep) => {
    return Object.fromEntries(
        Object.entries(obj).filter(([key, _]) => keysToKeep?.includes(key))
    );
};
